import { ModuleEntry, ModuleSection, visibleSections } from './module-access.logic';
import { GrupoVisibilidad } from './juicio-sidebar.logic';

/** Cuántos flujos tiene el cliente en cada `suitemodule`. null = todavía no llegaron. */
export type FlujosPorModulo = Readonly<Record<string, number>> | null;

/** Mismo filtro que los hijos de flujo del menú: sin Pendientes, con id y con módulo. */
export function contarFlujosPorModulo(grupos: GrupoVisibilidad[] | null | undefined): Record<string, number> {
  const cuenta: Record<string, number> = {};
  for (const grupo of Array.isArray(grupos) ? grupos : []) {
    if (!grupo?.name || grupo.name === 'Pendientes' || grupo.id == null || !grupo.suitemodule) continue;
    cuenta[grupo.suitemodule] = (cuenta[grupo.suitemodule] ?? 0) + 1;
  }
  return cuenta;
}

/**
 * Un módulo cuyos hijos son flujos solo existe si el cliente tiene al menos uno.
 * Mientras no llegan tampoco se muestra: aparecer y desaparecer confunde más que tardar.
 */
export function tieneSusFlujos(module: ModuleEntry, flujos: FlujosPorModulo): boolean {
  if (!module.suitemodule) return true;
  return (flujos?.[module.suitemodule] ?? 0) > 0;
}

/**
 * Módulo donde entra la suite cuando no hay nada que conservar y el dominio no
 * tiene Notificaciones: el primero con flujos; sin flujos, el primero que navega.
 */
export function moduloDeEntrada<T extends { module: ModuleEntry; children: unknown[] }>(
  items: readonly T[],
): T | null {
  const habilitado = (i: T) => i.module.disabled !== true;
  return items.find((i) => habilitado(i) && !!i.module.suitemodule && i.children.length > 0)
    ?? items.find((i) => habilitado(i) && (!!i.module.link || i.children.length > 0))
    ?? null;
}

/** Secciones del menú de la suite: flag del dominio, permiso del perfil y flujos del cliente. */
export function seccionesDeSuite(
  catalogo: ModuleEntry[],
  tienePermiso: (permiso: string) => boolean,
  flujos: FlujosPorModulo,
): ModuleSection[] {
  return visibleSections(catalogo.filter((module) => tieneSusFlujos(module, flujos)), tienePermiso);
}
